<template>
    <div class="wk-input wk-input-box">
        <span class="input-left-label" v-if="label">{{labelOver}}</span>
        <div class="posi-relative">
            <!-- <p class="posi-absolute bg-white" 
                style="left: .85rem;z-index: 10;top: 10px;font-size: 16px; right:auto;">
                {{inputValFmt}}</p> -->
            <input-base v-if="type!='password'" :type='type' v-model="inputVal" :initVal="value" ref="inputRef"
                :placeholder="placeholder" :maxlength="maxlength" :readonly="readonly" @blur="$emit('blur')"/>
            <input-pwd v-else v-model="inputVal" :placeholder="placeholderOver" :maxlength="maxlength" />
            <p class="bottom-box flex txt-gray-g" v-if="tip">
                <span>*</span>
                {{tip}}
            </p>
            <p style="padding-top:.1rem; font-size:.6rem;"> {{inputValStr}} </p>
            <div class="posi-absolute right-box">
                <slot></slot>
            </div>
        </div>
    </div>
</template>
 
<script>
    export default {
        name: 'inputlsit',
        props: ['label', 'type','placeholder','maxlength','value','tip','readonly'],
        mounted(){
            this.labelOver = this.label;
        },
        watch:{
            inputVal(newVal){
                if(this.type == 'tel' && newVal.length > 11){
                    this.inputVal = newVal.substr(0,11); 
                }
                this.inputValStr = this.$tools.Arabia_To_Chinese(this.inputVal);
                this.inputValFmt = this.format(this.inputVal);
                this.$emit('input',this.inputVal.trim());
            },
            value(){      
                if(this.type!='password'){
                    this.inputValStr = this.$tools.Arabia_To_Chinese(this.inputVal);
                    this.inputValFmt = this.format(this.inputVal);
                    this.$refs.inputRef.setValue(this.value);
                }  
            }
        },
        data(){
            return{
                inputVal:'',
                inputValStr:'',
                inputValFmt:'',
                labelOver:'',
                placeholderOver:''
            }
        },
        methods:{
            format (num) {
                return (num+ '').replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g,'$1,');
            }
        }
    }
</script>
<style lang="less" scoped>
    .wk-input{
        >div{
            >p.bottom-box{
                padding-top: .2rem;
                margin-bottom: -.2rem;
                span{
                    padding:.15rem .2rem 0 .1rem;
                }
            }
            >div.right-box{
                top:0;
                left:100%;
                >img{
                    margin:.5rem 0 0 .5rem;
                }
            }
        }
    }
    .wk-input + .wk-input{
        margin-top:.8rem;
    }
</style>



// WEBPACK FOOTER //
// src/components/BaseCpts/wkInputDin.vue